import { render, staticRenderFns } from "./searchRes.vue?vue&type=template&id=182ccbb0&scoped=true"
import script from "./searchRes.vue?vue&type=script&lang=js"
export * from "./searchRes.vue?vue&type=script&lang=js"
import style0 from "./searchRes.vue?vue&type=style&index=0&id=182ccbb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ccbb0",
  null
  
)

export default component.exports